import React, { useState } from "react";
import axios from "axios";


const useColors = () => {
    const theams = {
        bright_red:[

        ],
        bright_bule :[
            '#55efc4', '#00b894', '#81ecec', '#00cec9', '#74b9ff', '#0984e3', '#a29bfe', '#6c5ce7', '#ffeaa7', '#fdcb6e', '#b2bec3', '#636e72', '#636e72', '#ff7675'
        ],
        bright:[

        ],
        morandi:[
            '#c08178',
            '#dfaa8e',
            '#ecd7ab',
            '#acb5a4',
            '#bdcad2',
            '#c8c1c9',
            '#cabfcb',
            '#dfd1c4',
            '#e1e1d0',
            '#f3e5e1',
            '#f1e9cd',
            '#d5ded0',
            '#d3dbde',
            '#e7e5e6',
        ]



    }
    const getTheamName = ()=>{
        return Object.keys(theams)
    }
    const getTheamColors = (theamName)=>{
        return theams[theamName] ||[]
    }
    return {
        getTheamName,
        getTheamColors,
    }
}
export { useColors }
